export default __webpack_public_path__ + "assets/images/pay_first.cd121e.webp";